import { connect } from 'react-redux'

import AccountReportComponent from './component'
import { getFilterParams, getDevelopmentMembers } from '../../../../../../store/strategistV2/dashboard/actions'
import { getAccountingReportData, clearStrategistPhase } from '../../../../../../store/strategistV2/strategist/actions'

const AccountReportContainer = connect(
  // Map state to props
  (state) => ({
    filterParams: state.strategistV2.dashboard.filterParams,
    accountingReportPhase: state.strategistV2.strategist.accountingReportPhase,
    accountingReportData: state.strategistV2.strategist.accountingReportData,
    developmentMembers:state.strategistV2.dashboard.developmentMembers,
  }),
  // Map actions to dispatch and props
  {
    getAccountingReportData,
    clearStrategistPhase,
    getFilterParams,
    getDevelopmentMembers,
  }
)(AccountReportComponent)

export default AccountReportContainer
